
import Vue from "vue";
import AppToolbarButton from "@/components/common/ToolbarButton.vue";
import { CompanyService } from "@/services/company-service";

interface IGiftItem {
	key:string;
	name:string;
	date:string;
	sortDate:number;
	badgeText:string;
	badgeClass:string;
}

export default Vue.extend({
	data(){
		return {
			open: false,
			loading: true,
			referrals: [] as any[],
			invites: [] as any[]
		};
	},
	computed: {
		pendingInvites():any[]{
			return this.invites.filter(i => i.status != "registered");
		},
		badgeCount():number{
			return this.referrals.length + this.pendingInvites.length;
		},
		items():IGiftItem[]{
			let referralItems:IGiftItem[] = this.referrals.map(r => ({
				key: "r" + r.id,
				name: r.referredCompanyName || this.$ct("new-account").toString(),
				date: this.formatDate(r.dateCreated),
				sortDate: new Date(r.dateCreated).getTime(),
				badgeText: (r.rewarded ? this.$ct("status.rewarded") : this.$ct("status.registered")).toString(),
				badgeClass: r.rewarded ? "badge-reward" : "badge-success"
			}));
			let inviteItems:IGiftItem[] = this.pendingInvites.map(i => ({
				key: "i" + i.id,
				name: i.email,
				date: this.formatDate(i.dateSent),
				sortDate: new Date(i.dateSent).getTime(),
				badgeText: this.$ct("status.invited").toString(),
				badgeClass: "badge-pending"
			}));
			return referralItems.concat(inviteItems)
				.sort((a, b) => b.sortDate - a.sortDate)
				.slice(0, 5);
		}
	},
	watch: {
		open(value:boolean){
			if (value){
				this.load();
			}
		}
	},
	methods: {
		formatDate(date:string):string{
			if (!date) return "";
			return new Date(date).toLocaleDateString();
		},
		goToReferrals(){
			this.open = false;
			if (this.$route.path != "/account/referrals"){
				this.$router.push("/account/referrals");
			}
		},
		async load(){
			this.loading = true;
			try{
				let data = await CompanyService.getReferrals();
				this.referrals = data.referrals;
				this.invites = data.invites;
			}catch(err){
				this.referrals = [];
				this.invites = [];
			}finally{
				this.loading = false;
			}
		}
	},
	components: {
		AppToolbarButton
	},
	i18nEx: {
		componentPrefix: "components.common-ReferralGiftDropdown"
	}
});
